import type { DeployState } from '@/stores/deploy-status';

export function DeployOverlay({ status, title, subtitle }: DeployState) {
  if (!status) return null;

  return (
    <div className="fixed inset-0 z-[10001] flex flex-col items-center justify-center bg-bg/40 backdrop-blur-sm animate-[forge-fade-in_0.2s_ease-out]">
      {/* Logo — forgeHeat glow animation */}
      <div className="animate-[forgeHeat_2.5s_ease-in-out_infinite] mb-6">
        <svg viewBox="0 0 100 100" width={72} height={72} fill="none">
          <defs>
            <linearGradient id="deploy-g" x1="50" y1="12" x2="50" y2="85" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="#fbbf24" />
              <stop offset="40%" stopColor="#f97316" />
              <stop offset="100%" stopColor="#dc2626" />
            </linearGradient>
          </defs>
          <path d="M24 80 L24 64 C24 34 34 18 50 18 C66 18 76 34 76 64 L76 80" stroke="url(#deploy-g)" strokeWidth="7" strokeLinecap="round" fill="none" />
          <line x1="14" y1="64" x2="86" y2="64" stroke="url(#deploy-g)" strokeWidth="7" strokeLinecap="round" />
        </svg>
      </div>

      {/* Sliding progress bar */}
      <div className="w-[180px] h-[3px] bg-surface-2 rounded-sm overflow-hidden mb-4">
        <div className="h-full rounded-sm bg-gradient-to-r from-red-600 via-orange to-amber-400 animate-[ldrSlide_1.8s_ease-in-out_infinite]" />
      </div>

      {/* Title */}
      <p className="text-[11px] font-bold tracking-[3px] text-ink-2 uppercase">
        {title}
      </p>

      {/* Subtitle */}
      <p className="text-xs text-ink-3 mt-1.5">
        {subtitle}
      </p>
    </div>
  );
}
